module.exports = __webpack_public_path__ + "img/eight2Green.fbf10447.jpg";